import { useEffect, useState } from "react";

export function useNavbarScroll(threshold = 20): boolean {
  const [rolou, setRolou] = useState(false);

  useEffect(() => {
    function aoRolar() {
      setRolou(window.scrollY > threshold);
    }

    window.addEventListener("scroll", aoRolar);
    return () => window.removeEventListener("scroll", aoRolar);
  }, [threshold]);

  return rolou;
}
